module.exports = __webpack_public_path__ + "dk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/dk.svg
// module id = 775
// module chunks = 0